var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReserveTableDetailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_3480391",
    clipPath: "url(#clip0_696_3416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.9753 12.7487H0V6.98663C0 5.27948 1.38385 3.89563 3.091 3.89563H34.8843C36.5914 3.89563 37.9753 5.27948 37.9753 6.98663V12.7487Z",
    fill: "#E94444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M37.9753 12.7487H0V37.0135C0 38.7206 1.38385 40.1045 3.091 40.1045H34.8843C36.5914 40.1045 37.9753 38.7206 37.9753 37.0135V12.7487Z",
    fill: "#FFF2E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.9876 35.0852C23.8813 35.0852 27.8484 31.1181 27.8484 26.2244C27.8484 21.3307 23.8813 17.3635 18.9876 17.3635C14.0938 17.3635 10.1267 21.3307 10.1267 26.2244C10.1267 31.1181 14.0938 35.0852 18.9876 35.0852Z",
    fill: "#E94444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.9876 31.7293C22.0278 31.7293 24.4925 29.2647 24.4925 26.2244C24.4925 23.1841 22.0278 20.7195 18.9876 20.7195C15.9473 20.7195 13.4827 23.1841 13.4827 26.2244C13.4827 29.2647 15.9473 31.7293 18.9876 31.7293Z",
    fill: "#EE6161"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.10031 21.9409C2.73447 21.9409 2.43799 21.6443 2.43799 21.2786V17.6135C2.43799 17.2477 2.73456 16.9512 3.10031 16.9512C3.46606 16.9512 3.76263 17.2477 3.76263 17.6135V21.2786C3.76271 21.6444 3.46614 21.9409 3.10031 21.9409Z",
    fill: "#EE6161"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5.60373 21.9409C5.23789 21.9409 4.94141 21.6443 4.94141 21.2786V17.6135C4.94141 17.2477 5.23798 16.9512 5.60373 16.9512C5.96948 16.9512 6.26605 17.2477 6.26605 17.6135V21.2786C6.26605 21.6444 5.96956 21.9409 5.60373 21.9409Z",
    fill: "#EE6161"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.10714 21.9409C7.74131 21.9409 7.44482 21.6443 7.44482 21.2786V17.6135C7.44482 17.2477 7.74139 16.9512 8.10714 16.9512C8.47289 16.9512 8.76946 17.2477 8.76946 17.6135V21.2786C8.76955 21.6444 8.47298 21.9409 8.10714 21.9409Z",
    fill: "#EE6161"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M3.10034 21.2785V23.4864C3.10034 24.0718 3.5748 24.5462 4.16012 24.5462H4.45566V33.9371C4.45566 34.5712 4.96965 35.0852 5.60379 35.0852C6.23783 35.0852 6.75191 34.5713 6.75191 33.9371V24.5461H7.04745C7.63277 24.5461 8.10723 24.0717 8.10723 23.4863V21.2784L3.10034 21.2785Z",
    fill: "#EE6161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M7.70974 24.5462H3.49777C2.91245 24.5462 2.43799 24.0717 2.43799 23.4864V21.2786H8.76952V23.4864C8.76952 24.0717 8.29506 24.5462 7.70974 24.5462Z",
    fill: "#EE6161"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M34.8748 21.0798C34.8748 19.1653 33.6194 17.6134 32.0708 17.6134C30.5222 17.6134 29.2668 19.1653 29.2668 21.0798C29.2668 22.0297 29.5761 22.89 30.0769 23.5159C30.3186 23.818 30.6051 24.0655 30.9228 24.2421V33.9371C30.9228 34.5711 31.4368 35.0852 32.0709 35.0852C32.7049 35.0852 33.219 34.5712 33.219 33.9371V24.2421C34.1948 23.6998 34.8748 22.4884 34.8748 21.0798Z",
    fill: "#EE6161"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M29.5018 9.45935C28.4775 9.45935 27.6472 8.62902 27.6472 7.60473V1.90845C27.6472 0.884161 28.4775 0.053833 29.5018 0.053833C30.5261 0.053833 31.3565 0.884161 31.3565 1.90845V7.60473C31.3565 8.62902 30.5261 9.45935 29.5018 9.45935Z",
    fill: "#F9C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M8.47327 9.45935C7.44898 9.45935 6.61865 8.62902 6.61865 7.60473V1.90845C6.61865 0.884161 7.44898 0.053833 8.47327 0.053833C9.49756 0.053833 10.3279 0.884161 10.3279 1.90845V7.60473C10.3279 8.62902 9.49756 9.45935 8.47327 9.45935Z",
    fill: "#F9C6C6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M34.884 3.89563H31.8799C33.587 3.89563 34.9709 5.27948 34.9709 6.98663V12.7488H37.975V6.98663C37.975 5.27948 36.5911 3.89563 34.884 3.89563Z",
    fill: "#D83131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M34.9709 12.7487V37.0135C34.9709 38.7206 33.587 40.1045 31.8799 40.1045H34.884C36.5911 40.1045 37.975 38.7206 37.975 37.0135V12.7487H34.9709Z",
    fill: "#FEE8C7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M34.7661 43.9462C39.8659 43.9462 44 39.812 44 34.7123C44 29.6126 39.8659 25.4784 34.7661 25.4784C29.6664 25.4784 25.5322 29.6126 25.5322 34.7123C25.5322 39.812 29.6664 43.9462 34.7661 43.9462Z",
    fill: "#EE6161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M34.7662 25.4784C34.2547 25.4784 33.7531 25.5207 33.2642 25.6007C37.6494 26.3182 40.996 30.1241 40.996 34.7123C40.996 39.3005 37.6495 43.1064 33.2642 43.8239C33.7531 43.9039 34.2547 43.9462 34.7662 43.9462C39.8659 43.9462 44.0001 39.812 44.0001 34.7123C44.0001 29.6126 39.8659 25.4784 34.7662 25.4784Z",
    fill: "#E94444"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M32.3658 40.1846C32.3591 40.1846 32.3524 40.1846 32.3455 40.1845C32.0056 40.1786 31.6852 40.0246 31.4682 39.7629L28.2411 35.8695C27.8303 35.3739 27.8991 34.6389 28.3948 34.2281C28.8904 33.8172 29.6252 33.8859 30.0363 34.3816L32.3969 37.2297L38.0599 30.8612C38.4876 30.3802 39.2244 30.3368 39.7057 30.7647C40.1868 31.1925 40.23 31.9294 39.8021 32.4105L33.2369 39.7935C33.0155 40.0425 32.6983 40.1846 32.3658 40.1846Z",
    fill: "#F9C6C6"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_696_3416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserveTableDetailIcon);
export default __webpack_public_path__ + "static/media/reserve-table-detail-icon.016d3acb60438dda1ba393b80f19233f.svg";
export { ForwardRef as ReactComponent };